/**
 *
 * @component 计划验收列表tab
 *
 **/

import { Form, Collapse, Image, Empty, Spin } from 'antd';
import { getPlansCheck } from '@/api/personCenter/projectSpace1.4';
import { CaretRightOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import './PlanCheck.scss';
const { Item } = Form;

function PlanCheck(props) {
    const { projectId, previewVideo } = props;
    const location = useLocation();
    const SEARCH = new URLSearchParams(location.search);
    const planCheckId = SEARCH.get('planCheckId');
    const [activeKey, setActiveKey] = useState([]);

    useEffect(() => {
        queryList();
    }, []);

    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);

    function queryList() {
        setLoading(true);
        getPlansCheck({ projectId })
            .then(({ data }) => {
                setList(
                    data.map(el => ({
                        ...el,
                        isShowFinish: false,
                        isShowPreCheck: false,
                    }))
                );
                if (planCheckId) {
                    setActiveKey([planCheckId]);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    }

    const STATUS_DICT = [
        {
            title: intl.get('projectSpace.unstart'),
            classType: 'default',
            icon: 'icon-remove',
        },
        {
            title: intl.get('projectSpace.unconfirm'),
            classType: 'default',
            icon: 'icon-remove',
        },
        {
            title: intl.get('projectSpace.underConstruction'),
            classType: 'default',
            icon: 'icon-remove',
        },
        {
            title: intl.get('projectSpace.unaccepted'),
            classType: 'danger',
            icon: 'icon-info-circle2',
        },
        {
            title: intl.get('base.qualified'),
            classType: 'success',
            icon: 'icon-Confirm',
        },
        {
            title: intl.get('base.disqualification'),
            classType: 'danger',
            icon: 'icon-info-circle2',
        },
    ];

    const { Panel } = Collapse;
    const panelHeader = ({ name, status }) => (
        <>
            <span className="plan-name">{name}</span>
            <i
                className={`filled ${STATUS_DICT[status].icon} title-icon type--${STATUS_DICT[status].classType}`}></i>
            <span className={`type--${STATUS_DICT[status].classType}`}>
                {STATUS_DICT[status].title}
            </span>
        </>
    );

    //   渲染动态列表里的  附件
    const calcAccessory = (list = []) => {
        const IMAGES = list.filter(el => el.fileType === '1');
        const [VIDEO] = list.filter(el => el.fileType === '2');

        return (
            <>
                {!!IMAGES.length && (
                    <div className="media-content-image">
                        <Image.PreviewGroup>
                            {IMAGES.map((el, idx) =>
                                idx < 4 ? (
                                    <Image
                                        data-num={`${
                                            IMAGES.length - 4 > 0
                                                ? '+' + (IMAGES.length - 4)
                                                : ''
                                        }`}
                                        key={idx}
                                        src={el.thumbUrl}
                                    />
                                ) : (
                                    <div className="hide-image" key={idx}>
                                        <Image src={el.thumbUrl} />
                                    </div>
                                )
                            )}
                        </Image.PreviewGroup>
                    </div>
                )}

                {VIDEO && (
                    <div
                        className="media-content-video"
                        onClick={() => previewVideo(VIDEO.originalUrl)}>
                        <Image
                            preview={false}
                            src={VIDEO.thumbUrl}
                            fallback={
                                require('@/assets/img/userCenter1.4/xqdefault.png')
                                    .default
                            }
                        />
                        <i className="filled icon-play-circle2 play-btn"></i>
                    </div>
                )}
            </>
        );
    };

    // 验收结果
    function CheckResult(checkData) {
        return (
            checkData && (
                <>
                    <Item label={intl.get('userCenter.accepter')}>
                        {checkData.checkName}
                    </Item>
                    <Item label={intl.get('userCenter.acceptanceTime')}>
                        {checkData.checkDate}
                    </Item>
                    {!!checkData.remark && (
                        <Item label={intl.get('userCenter.acceptanceExplain')}>
                            <div className="show-space">{checkData.remark}</div>
                        </Item>
                    )}
                    {!!checkData.adjunct.length && (
                        <Item>{calcAccessory(checkData.adjunct)}</Item>
                    )}
                </>
            )
        );
    }

    // 完成信息
    function FinishResult(finishData) {
        return (
            finishData && (
                <>
                    <Item label={intl.get('projectSpace.completer')}>
                        {finishData.finishName}
                    </Item>
                    <Item label={intl.get('projectSpace.completeTime')}>
                        {finishData.finishDate}
                    </Item>
                    {!!finishData.remark && (
                        <Item label={intl.get('projectSpace.completeRemark')}>
                            <div className="show-space">
                                {finishData.remark}
                            </div>
                        </Item>
                    )}
                    {!!finishData.adjunct.length && (
                        <Item>{calcAccessory(finishData.adjunct)}</Item>
                    )}
                </>
            )
        );
    }

    const lastCheck = (el, idx, key) => {
        return (
            !!el.checkData?.[key] && (
                <>
                    <div
                        className="native-link"
                        onClick={() => toggleBlock(idx, 'isShowPreCheck')}>
                        {el.isShowPreCheck
                            ? intl.get('directory.fold')
                            : intl.get('directory.expand')}
                        {intl.get('projectSpace.lastReason')}
                    </div>
                    {el.isShowPreCheck && CheckResult(el.checkData?.[key])}
                </>
            )
        );
    };

    const toggleBlock = (idx, key) => {
        setList(prev => {
            const next = [...prev];
            next[idx][key] = !next[idx][key];
            return next;
        });
    };

    const onOpenChange = key => {
        setActiveKey(key);
    };

    return (
        <div className="check-plans-tab">
            <Form labelAlign="left">
                <Spin size="large" spinning={loading}>
                    {!list.length && <Empty />}
                    <Collapse
                        ghost
                        activeKey={activeKey}
                        onChange={onOpenChange}
                        expandIcon={e => {
                            return !e.children ? (
                                <CaretRightOutlined />
                            ) : (
                                <CaretRightOutlined
                                    rotate={e.isActive ? 90 : 0}
                                />
                            );
                        }}>
                        {list.map((el, idx) => (
                            <Panel
                                key={el.id}
                                collapsible={el.status > 2 ? '' : 'disabled'}
                                header={panelHeader(el)}>
                                {el.status > 2 && (
                                    <div
                                        key={el.id}
                                        className="custom-content-box">
                                        {['4', '5'].includes(el.status) ? (
                                            <>
                                                {CheckResult(
                                                    el.checkData?.checkLately
                                                )}

                                                {el.status === '5' &&
                                                    lastCheck(
                                                        el,
                                                        idx,
                                                        'checkLast'
                                                    )}

                                                <div
                                                    className="native-link"
                                                    onClick={() =>
                                                        toggleBlock(
                                                            idx,
                                                            'isShowFinish'
                                                        )
                                                    }>
                                                    {el.isShowFinish
                                                        ? intl.get(
                                                              'directory.fold'
                                                          )
                                                        : intl.get(
                                                              'directory.expand'
                                                          )}
                                                    {intl.get(
                                                        'projectSpace.completeRemark'
                                                    )}
                                                </div>

                                                {el.isShowFinish &&
                                                    FinishResult(
                                                        el.finishData
                                                            ?.finishLately
                                                    )}
                                            </>
                                        ) : (
                                            <>
                                                {FinishResult(
                                                    el.finishData?.finishLately
                                                )}

                                                {lastCheck(
                                                    el,
                                                    idx,
                                                    'checkLately'
                                                )}
                                            </>
                                        )}
                                    </div>
                                )}
                            </Panel>
                        ))}
                    </Collapse>
                </Spin>
            </Form>
        </div>
    );
}

export default PlanCheck;
